import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.2504 1.2504)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5ZM11.5 15.75H10V9.75H11.5V15.75ZM10.75 5.75C11.3023 5.75 11.75 6.19772 11.75 6.75C11.75 7.30228 11.3023 7.75 10.75 7.75C10.1977 7.75 9.75 7.30228 9.75 6.75C9.75 6.19772 10.1977 5.75 10.75 5.75Z",
			fill: "currentColor"
		})
	})
});
export default SvgInfoCircle;
